import script from "./footNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./footNavigation.vue?vue&type=script&setup=true&lang=js"

import "./footNavigation.vue?vue&type=style&index=0&id=8eb8fba2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8eb8fba2"]])

export default __exports__